import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, signal } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { HomeReelsComponent } from "../../home-reels/home-reels.component";
import { HomeComponent } from "../../home/home.component";
import { ReelsService } from "@src/app/servicios/reels.service";
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
  selector: "app-device-based",
  imports: [HomeReelsComponent, HomeComponent],
  templateUrl: "./device-based.component.html",
  styleUrl: "./device-based.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceBasedComponent implements OnInit, OnDestroy {
  @Input() showFecha: boolean;
  isMobile = signal(undefined);
  isReels = signal(false);
  fromReelsSub: Subscription;
  reelsSub: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private reelsService: ReelsService,
    private deviceService: DeviceDetectorService,
  ) {
    this.reelsService.setIsMobile(this.deviceService.isMobile());
  }

  ngOnInit(): void {
    // Comprueba si la portada de reels está activa en la configuración y si el dispositivo es móvil.
    this.activatedRoute.data.subscribe({
      next: ({ isMobile }) => {
        this.isMobile.set(isMobile);
        // if (this.isMobile) {
        //   this.reelsSub = this.reelsService.getIsReels().subscribe((isReels) => {
        //     this.isReels.set(isReels);
        //   });
        // }
      },
      error: () => {
        this.isMobile.set(false);
      },
    });
  }

  ngOnDestroy(): void {
    if (this.fromReelsSub) this.fromReelsSub.unsubscribe();
    if (this.reelsSub) this.reelsSub.unsubscribe();
  }
}
